export default "__VITE_ASSET__BKxVnnB0__"